import React, {use, useEffect, useState} from 'react';
import { connect } from 'react-redux';
import LogoSvg from '../../..//svg/Logo.js';
import { useCookies } from 'react-cookie';
import {cookies_string} from '../../../config.js';
import { Login } from '../../../actions/actions.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchUserDataById } from '../../../services2/users.service.js';
import { teacherFetchSchoolInfo } from '../../../services2/schools.service.js';
import { useSetting } from '../../../util/useSetting.js';
import SettingPopup from './SettingPopup.js';

function Component(props) {
    const {fontSize,updateFontSize} = useSetting();
    const navigate = useNavigate();
    const location = useLocation();
    const [ __, _, removeCookie] = useCookies([`${cookies_string}_cred`,`${cookies_string}_token`]);
    const [isShowMenu,setisShowMenu]=useState(false)
	const handleLogout=()=>{
		props.dispatch(Login(false))
        removeCookie(`${cookies_string}_token`,'/')
        removeCookie(`${cookies_string}_cred`,'/')   
	}
    const toggleMenu=()=>{setisShowMenu(!isShowMenu)}
    const handleRoute=(route)=>()=>{
        navigate(`/platform2/${route}`);
    }

    const [user,setuser]=useState(null)
    const [school,setSchool]=useState(null)

    async function fetchData(){
        let result = await fetchUserDataById(props.token.token)
        if( result.result){
            setuser(result.result)
            let schoolData = await teacherFetchSchoolInfo(props.token.token)
            if(schoolData.result){
                setSchool(schoolData.result)
            }
            
        }
    }
    useEffect(()=>{
        if(props.token.token)
            fetchData()
    },[props.token.token])

    const [isSettingMenuVisible,setisSettingMenuVisible]=useState(false)

    const isMobile=window.innerWidth<1024;
    if(props.token.usertype==='student'&&location.pathname.split('/')[3]!==undefined&&location.pathname.split('/')[2]==='missions'){
        return(<div/>)
    }
    if(props.token.usertype==='p-student'&&location.pathname.split('/')[3]!==undefined&&location.pathname.split('/')[2]==='missions'){
        return(<div/>)
    }
    if (location.pathname.split('/')[2] !== undefined && location.pathname.split('/')[2] === 'task-4') {
        return (<div />)
    }
    if(location.pathname.split('/')[2]==='missions'&&location.pathname.split('/')[3])
        return null;
    if(location.pathname.split('/')[2]==='research-practices'&&location.pathname.split('/')[3]&&location.pathname.split('/')[3]!=='preview')
        return null;
     if(location.pathname.split('/')[2]==='studentmissions'&&location.pathname.split('/')[3])
        return null
    return(
        <div className='bg-[white] w-full flex flex-row justify-between items-center px-[16px] py-[24px] text-[1rem]' style={{overflowX:'auto', fontSize: fontSize}}>
            <div>
                {school?.name?`${school?.name}`:''}
            </div>
  
            <div className='flex flex-row items-center' style={{gap:isMobile?'8px':'24px'}}>
                <div>{user?.name?`姓名: ${user?.name}`:props.token?.username}</div>
                <div>{user?.class?`班級: ${user?.class}`:''}</div>

                <button className='px-[18px] py-[4px] rounded-full flex flex-row items-center text-[white] gap-[8px] noto-san-hk font-[600]' style={{background:'linear-gradient(to right, #34778C, #63BBD1)'}} onClick={()=>setisSettingMenuVisible(!isSettingMenuVisible)}>
                    <img src='/secondary/setting.png' alt='設定' />
                    設定
                </button>
            </div>
            {isSettingMenuVisible && (
                <SettingPopup onClose={()=>setisSettingMenuVisible(false)}/>    
            )}
        </div>
    )
}
export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)